import { track } from "@amplitude/analytics-react-native";
import DeleteCommentDocument from "src/api/graphql/__generated__/documents/DeleteCommentDocument";
import RemoveCommentDocument from "src/api/graphql/__generated__/documents/RemoveCommentDocument";
import ReportEntityDocument from "src/api/graphql/__generated__/documents/ReportEntityDocument";
import EntityType from "src/api/graphql/__generated__/enums/EntityType";
import ContextMenu from "src/components/ContextMenu";
import useGlobalStore from "src/stores/useGlobalStore";
import { alert, prompt } from "src/swsh-native";
import { CommentAttachmentType } from "../components/CommentBubble";

const createRenderCommentContextMenu = ({
	isSelf,
	commentId,
	isAdmin,
}: {
	isSelf: boolean;
	commentId: string;
	isAdmin: boolean;
}) => {
	const renderContextMenu: CommentAttachmentType.ContextMenu["renderContextMenu"] = ({
		children,
	}) => {
		return (
			<ContextMenu.Root>
				<ContextMenu.Trigger asChild>{children}</ContextMenu.Trigger>
				<ContextMenu.Content>
					{isSelf && (
						<ContextMenu.Item
							key="delete"
							destructive
							onSelect={async () => {
								track("comment_delete_open");
								alert({
									title: "Delete Message",
									message:
										"Are you sure you want to delete this message? This action cannot be undone.",
									buttons: [
										{
											text: "Cancel",
											style: "cancel",
											onPress: () => {
												track("comment_delete_cancel");
											},
										},
										{
											text: "Delete",
											style: "destructive",
											onPress: async () => {
												track("comment_delete_confirm");
												const { apolloClient } = useGlobalStore.getState();
												await apolloClient?.mutate({
													mutation: DeleteCommentDocument,
													variables: {
														input: {
															commentId,
														},
													},
												});
											},
										},
									],
								});
							}}
						>
							<ContextMenu.ItemTitle>Delete</ContextMenu.ItemTitle>
						</ContextMenu.Item>
					)}
					{!isSelf && isAdmin && (
						<ContextMenu.Item
							key="remove"
							destructive
							onSelect={async () => {
								track("comment_remove_open");
								alert({
									title: "Remove Message",
									message:
										"Are you sure you want to remove this message? This action cannot be undone.",
									buttons: [
										{
											text: "Cancel",
											style: "cancel",
											onPress: () => {
												track("comment_remove_cancel");
											},
										},
										{
											text: "Remove",
											style: "destructive",
											onPress: async () => {
												track("comment_remove_confirm");
												const { apolloClient } = useGlobalStore.getState();
												await apolloClient?.mutate({
													mutation: RemoveCommentDocument,
													variables: {
														input: {
															commentId,
														},
													},
												});
											},
										},
									],
								});
							}}
						>
							<ContextMenu.ItemTitle>Remove</ContextMenu.ItemTitle>
						</ContextMenu.Item>
					)}
					{!isSelf && (
						<ContextMenu.Item
							key="report"
							destructive
							onSelect={() => {
								track("comment_report_open");
								prompt({
									title: "Report",
									message:
										"Please tell us why you are reporting this content. Your message is reported directly to swsh.",
									buttons: [
										{
											text: "Cancel",
											style: "cancel",
											onPress: () => {
												track("comment_report_cancel");
											},
										},
										{
											text: "Report",
											style: "destructive",
											onPress: async (reason) => {
												track("comment_report_confirm");
												const { apolloClient } = useGlobalStore.getState();
												await apolloClient?.mutate({
													mutation: ReportEntityDocument,
													variables: {
														input: {
															entityId: commentId,
															entityType: EntityType.Comment,
															reason,
														},
													},
												});
											},
										},
									],
								});
							}}
						>
							<ContextMenu.ItemTitle>Report</ContextMenu.ItemTitle>
						</ContextMenu.Item>
					)}
				</ContextMenu.Content>
			</ContextMenu.Root>
		);
	};
	return renderContextMenu;
};
export default createRenderCommentContextMenu;
